/**
 * Prompt Service
 */

import { promptRepository } from "./promptRepository";
import { promptApiService } from "./promptApiService";

export class PromptService {
  async getFreshPrompt(): Promise<string> {
    return await promptApiService.fetchFresh();
  }

  async getSavedPrompt(userEmail: string): Promise<string | null> {
    return await promptRepository.getSavedPrompt(userEmail);
  }

  async savePrompt(prompt: string, userEmail: string): Promise<void> {
    await promptRepository.saveSavedPrompt(prompt, userEmail);
  }

  async resetSystemPrompt(userEmail: string): Promise<string> {
    await promptRepository.clearSavedPrompt(userEmail);
    return await promptApiService.fetchFresh();
  }
}

export const promptService = new PromptService();
